export default __webpack_public_path__ + "static/media/icon_responseTime.4afdbfad.svg";